import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ModalProvider } from './shared/modal/ModalBase/context/ModalProvider'

// Import styles in the correct order
//import './styles/styles.css'  // Component styles
import './../public/icons/style.css' 
import '@/styles/styles.css';

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  /*<React.StrictMode*/
  <BrowserRouter>
    <ModalProvider>
        <App />
    </ModalProvider>
  </BrowserRouter>
  /*</React.StrictMode*/
)
